import type {WidgetFragment} from 'nutshell-graphql-types';

import {CollapsibleCardWidget} from '../../../core/card/collapsible-card-widget';

import {SummaryFieldLabel} from './summary-field-label';

import styles from './summary-widget-content.module.css';

interface Props {
    widget: WidgetFragment;
    fields: React.ReactNode;
    tags: React.ReactNode;
    isLoading: boolean;
    error: string | null | undefined;
    setError: (error: string | null | undefined) => void;
}
export function SummaryWidgetContent(props: Props) {
    return (
        <CollapsibleCardWidget
            widget={props.widget}
            isLoading={props.isLoading}
            errorProps={{
                error: props.error,
                setError: props.setError,
            }}
            hasBorder={true}
        >
            <div className='px-12 flex gap-8 flex-dir-col'>
                <div className={styles['container']}>{props.fields}</div>
                {props.tags && (
                    <div>
                        <SummaryFieldLabel>Tags</SummaryFieldLabel>
                        <div>{props.tags}</div>
                    </div>
                )}
            </div>
        </CollapsibleCardWidget>
    );
}
